function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import { Field, Form as FormikForm, Formik } from "formik";
import React, { useState, useRef, useCallback, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import * as Yup from "yup";
import { UserContext, FilterContext } from "../index";
import { EDIT_PERSONAL_SETTINGS_MUTATION, ORGANISATION_DELETE_MUTATION, PROFILE_INFO_DETAILS_QUERY } from "./query";
import { MdPerson } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import { ORGANISATION_DETAILS_QUERY } from "../SideMenu/query";
import Loader from "./../Loader/Loader";
var PersonalInfoSchema = Yup.object().shape({
  displayName: Yup.string().required("Required").matches(/^[\u4E00-\u9FFF A-Za-z0-9'.-]+$/, "Invalid characters"),
  email: Yup.string().email().required("Required")
});
var PersonalInfo = function PersonalInfo(props) {
  var _organisationData$pro, _organisationData$pro2, _organisationData$pro5, _organisationData$pro6, _organisationData$pro7, _organisationData$pro8, _organisationData$pro9, _completedCrop$width, _completedCrop$height;
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user,
    setUser = _React$useContext.setUser;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    showCropImages = _useState2[0],
    setShowCropImages = _useState2[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showDeleteModal = _React$useState2[0],
    setShowDeleteModal = _React$useState2[1];
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    organisationUserCount = _React$useContext2.organisationUserCount,
    role = _React$useContext2.role;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _useQuery = useQuery(PROFILE_INFO_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId
      },
      skip: !organisationId
    }),
    organisationData = _useQuery.data,
    organisationError = _useQuery.error,
    organisationLoading = _useQuery.loading;
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    upImg = _useState4[0],
    setUpImg = _useState4[1];
  var imgRef = useRef(null);
  var previewCanvasRef = useRef(null);
  var _useState5 = useState({
      unit: "%",
      width: 60,
      aspect: 1
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    crop = _useState6[0],
    setCrop = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    completedCrop = _useState8[0],
    setCompletedCrop = _useState8[1];
  var _useState9 = useState((_organisationData$pro = organisationData === null || organisationData === void 0 ? void 0 : (_organisationData$pro2 = organisationData.profileInfoDetails) === null || _organisationData$pro2 === void 0 ? void 0 : _organisationData$pro2.profileUrl) !== null && _organisationData$pro !== void 0 ? _organisationData$pro : null),
    _useState10 = _slicedToArray(_useState9, 2),
    croppedImage = _useState10[0],
    setCroppedImage = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    imageStatus = _useState12[0],
    setImageStatus = _useState12[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    showErrModal = _React$useState4[0],
    setShowErrModal = _React$useState4[1];
  React.useEffect(function () {
    var _organisationData$pro3;
    if (organisationData && organisationData !== null && organisationData !== void 0 && organisationData.profileInfoDetails && organisationData !== null && organisationData !== void 0 && (_organisationData$pro3 = organisationData.profileInfoDetails) !== null && _organisationData$pro3 !== void 0 && _organisationData$pro3.profileUrl) {
      var _organisationData$pro4;
      setCroppedImage(organisationData === null || organisationData === void 0 ? void 0 : (_organisationData$pro4 = organisationData.profileInfoDetails) === null || _organisationData$pro4 === void 0 ? void 0 : _organisationData$pro4.profileUrl);
    }
  }, [organisationData]);
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
    setShowErrModal(false);
  };
  var onSelectFile = function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        return setUpImg(reader.result);
      });
      reader.readAsDataURL(e.target.files[0]);
      setShowCropImages(true);
    }
  };
  var onLoad = useCallback(function (img) {
    imgRef.current = img;
  }, []);
  var getCroppedImage = function getCroppedImage() {
    var image = imgRef.current;
    var canvas = previewCanvasRef.current;
    var crop = completedCrop;
    var scaleX = image.naturalWidth / image.width;
    var scaleY = image.naturalHeight / image.height;
    var ctx = canvas.getContext("2d");
    var pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(image, crop.x * scaleX, crop.y * scaleY, crop.width * scaleX, crop.height * scaleY, 0, 0, crop.width, crop.height);
    var base64Image = canvas.toDataURL("image/jpeg");
    setCroppedImage(base64Image);
    setShowCropImages(false);
  };
  var _useMutation = useMutation(EDIT_PERSONAL_SETTINGS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    editPersonalSettings = _useMutation2[0],
    editing = _useMutation2[1].loading;
  var handleClose = function handleClose() {
    setShowCropImages(null);
  };
  var handleRemovePhoto = function handleRemovePhoto() {
    setUpImg(null);
    setCompletedCrop(null);
    setCroppedImage(null);
    setImageStatus("deleted");
  };
  function handleSubmit(_x, _x2) {
    return _handleSubmit.apply(this, arguments);
  } // Guards must come after ALL hooks above, otherwise an early return on the
  // loading render skips the later hooks and breaks the Rules of Hooks.
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!editing) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.prev = 2;
            _context.next = 5;
            return editPersonalSettings({
              variables: {
                displayName: values.displayName,
                profilePicture: imageStatus == "deleted" ? user === null || user === void 0 ? void 0 : user.profileUrl : (user === null || user === void 0 ? void 0 : user.profileUrl) == croppedImage ? null : croppedImage,
                imageStatus: imageStatus
              },
              update: function update(_cache, updateResponse) {
                var _updateResponse$data, _updateResponse$data2;
                var updatedToken = updateResponse === null || updateResponse === void 0 ? void 0 : (_updateResponse$data = updateResponse.data) === null || _updateResponse$data === void 0 ? void 0 : _updateResponse$data.editPersonalSettings;
                var tokenData = jwtDecode(updateResponse === null || updateResponse === void 0 ? void 0 : (_updateResponse$data2 = updateResponse.data) === null || _updateResponse$data2 === void 0 ? void 0 : _updateResponse$data2.editPersonalSettings);
                if (!updatedToken) return;
                setUser(_objectSpread(_objectSpread({}, user), {}, {
                  displayName: values.displayName,
                  profileUrl: tokenData === null || tokenData === void 0 ? void 0 : tokenData.profileUrl
                }));
                setCroppedImage(tokenData === null || tokenData === void 0 ? void 0 : tokenData.profileUrl);
                localStorage.setItem("token", updatedToken);
              }
            });
          case 5:
            toast.success("Profile updated successfully!");
            setImageStatus(null);
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            actions.setFieldError("formError", "Something went wrong! Please try again.");
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  if (organisationLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (organisationError) {
    return /*#__PURE__*/React.createElement("div", null, "\"Something went wrong, pls refresh the page.\"");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "personal-settings-info-container p-2 pt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-wrapper"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      displayName: (_organisationData$pro5 = organisationData === null || organisationData === void 0 ? void 0 : (_organisationData$pro6 = organisationData.profileInfoDetails) === null || _organisationData$pro6 === void 0 ? void 0 : _organisationData$pro6.displayName) !== null && _organisationData$pro5 !== void 0 ? _organisationData$pro5 : "",
      email: (_organisationData$pro7 = organisationData === null || organisationData === void 0 ? void 0 : (_organisationData$pro8 = organisationData.profileInfoDetails) === null || _organisationData$pro8 === void 0 ? void 0 : _organisationData$pro8.emailId) !== null && _organisationData$pro7 !== void 0 ? _organisationData$pro7 : "",
      profilePhoto: ""
    },
    validationSchema: PersonalInfoSchema,
    onSubmit: handleSubmit
  }, function (_ref) {
    var isSubmitting = _ref.isSubmitting,
      errors = _ref.errors,
      setFieldValue = _ref.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("h4", {
      className: "text-dark mb-4"
    }, "Personal Info"), /*#__PURE__*/React.createElement(Field, {
      name: "displayName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "float-left text-muted"
      }, "Full Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error float-right small text-danger"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({}, field, {
        type: "text",
        placeholder: "Enter full name",
        isInvalid: meta.error && meta.touched,
        required: true,
        onBlur: field.onBlur,
        disabled: role == "Member"
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "email"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "float-left text-muted"
      }, "Email Address"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error float-right small text-danger"
      }, meta.error) : null, /*#__PURE__*/React.createElement(Form.Control, _extends({}, field, {
        type: "text",
        placeholder: "Enter email address",
        isInvalid: meta.error && meta.touched,
        required: true,
        disabled: true
      })));
    }), /*#__PURE__*/React.createElement(Field, {
      name: "profilePhoto"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "float-left text-muted"
      }, "Profile Picture"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(Form.Label, {
        className: "error float-right small text-danger"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "personal-info-profile-photo-upload-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "personal-info-profile-photo-upload-icon-card"
      }, croppedImage === null ? /*#__PURE__*/React.createElement(MdPerson, {
        className: "personal-info-profile-icon"
      }) : /*#__PURE__*/React.createElement("img", {
        src: croppedImage,
        className: "personal-info-profile-images"
      })), /*#__PURE__*/React.createElement("div", {
        className: "personal-info-profile-photo-upload-photo-card-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "personal-info-profile-photo-upload-photo-card-data"
      }, /*#__PURE__*/React.createElement("label", {
        "for": "inputUpload",
        className: "custom-file-upload"
      }, "Upload your photo"), croppedImage ? /*#__PURE__*/React.createElement("label", {
        htmlFor: "inputUpload",
        className: "profile-photo-remove",
        onClick: function onClick() {
          return handleRemovePhoto();
        }
      }, "Remove photo") : null), /*#__PURE__*/React.createElement("label", {
        className: "custom-file-upload-text"
      }, "Profile picture should be in the standard format png or jpg."), /*#__PURE__*/React.createElement("input", {
        id: "inputUpload",
        type: "file",
        onChange: onSelectFile
      }))));
    }), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "text-danger small"
    }, errors.formError) : null, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: "mt-2",
      disabled: editing || isSubmitting
    }, editing ? "Updating..." : "Save Personal Info"));
  })), role == "Admin" && organisationData !== null && organisationData !== void 0 && organisationData.profileInfoDetails && (organisationData === null || organisationData === void 0 ? void 0 : (_organisationData$pro9 = organisationData.profileInfoDetails) === null || _organisationData$pro9 === void 0 ? void 0 : _organisationData$pro9.organisationCreatedUser).toLowerCase() == (user === null || user === void 0 ? void 0 : user.emailId.toLowerCase()) ? /*#__PURE__*/React.createElement("div", {
    className: "delete-account-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "delete-account-wrapper-header"
  }, "Delete Account "), /*#__PURE__*/React.createElement("div", {
    className: "delete-account-wrapper-content"
  }, "Deleting your account will affect all your account & your company data. Make sure you are 100% sure you want to delete your account before proceeding."), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: "mt-2",
    variant: "danger",
    onClick: function onClick() {
      return setShowDeleteModal(true);
    }
  }, "Delete Account")) : null, /*#__PURE__*/React.createElement(Modal, {
    show: showCropImages,
    onHide: handleClose,
    centered: true,
    size: "md",
    contentClassName: "new-employee-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "profile-info-saved-crop-image-modal-title"
  }, /*#__PURE__*/React.createElement(Modal.Title, null, "Crop your photo")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "profile-info-saved-crop-image-modal-body"
  }, /*#__PURE__*/React.createElement(ReactCrop, {
    src: upImg,
    onImageLoaded: onLoad,
    crop: crop,
    onChange: function onChange(c) {
      return setCrop(c);
    },
    onComplete: function onComplete(c) {
      return setCompletedCrop(c);
    },
    circularCrop: true
    // locked={true}
  }), /*#__PURE__*/React.createElement("canvas", {
    ref: previewCanvasRef
    // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
    ,
    style: {
      width: Math.round((_completedCrop$width = completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.width) !== null && _completedCrop$width !== void 0 ? _completedCrop$width : 0),
      height: Math.round((_completedCrop$height = completedCrop === null || completedCrop === void 0 ? void 0 : completedCrop.height) !== null && _completedCrop$height !== void 0 ? _completedCrop$height : 0),
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "profile-info-saved-crop-image-button-header"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    className: "profile-info-cancel-crop-image-button",
    size: "sm",
    onClick: function onClick() {
      return handleClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "profile-info-saved-crop-image-button",
    size: "sm",
    onClick: function onClick() {
      return getCroppedImage();
    }
  }, "Save photo")))), /*#__PURE__*/React.createElement(DeleteAccountModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose,
    userId: user === null || user === void 0 ? void 0 : user.userId,
    organisationId: organisationId,
    organisationUserCount: organisationUserCount,
    history: props === null || props === void 0 ? void 0 : props.history,
    showErrModal: showErrModal,
    setShowErrModal: setShowErrModal
  }));
};
var DeleteAccountModal = function DeleteAccountModal(props) {
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose,
    userId = props.userId,
    organisationId = props.organisationId,
    organisationUserCount = props.organisationUserCount,
    history = props.history,
    showErrModal = props.showErrModal,
    setShowErrModal = props.setShowErrModal;
  if (showDeleteModal === null) {
    return null;
  }
  var _useLazyQuery = useLazyQuery(ORGANISATION_DETAILS_QUERY, {
      variables: {
        userId: userId,
        from: "web"
      },
      fetchPolicy: "network-only",
      skip: !userId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getDeleteUserCountDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    organisationDetailsData = _useLazyQuery2$.data,
    organisationDetailsError = _useLazyQuery2$.error,
    organisationDetailsLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    getDeleteUserCountDetails();
  }, [showDeleteModal]);
  var _useMutation3 = useMutation(ORGANISATION_DELETE_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    organisationDelete = _useMutation4[0],
    organisationDeleteLoading = _useMutation4[1].loading;
  var handleDeleteTeam = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var variables, response, _localStorage, _localStorage$removeI, _localStorage2, _localStorage2$remove, _localStorage3, _localStorage3$remove;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!organisationDeleteLoading) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return");
          case 2:
            variables = {
              userId: userId,
              organisationId: organisationId
            };
            _context2.prev = 3;
            _context2.next = 6;
            return organisationDelete({
              variables: variables
            });
          case 6:
            response = _context2.sent;
            if (!(!response || !response.data || response.data.organisationDelete === null)) {
              _context2.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            handleDeleteClose();
            toast.success("Organisation deleted successfully!");
            (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$removeI = _localStorage.removeItem) === null || _localStorage$removeI === void 0 ? void 0 : _localStorage$removeI.call(_localStorage, "token");
            (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : (_localStorage2$remove = _localStorage2.removeItem) === null || _localStorage2$remove === void 0 ? void 0 : _localStorage2$remove.call(_localStorage2, "signupUrlParams");
            (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : (_localStorage3$remove = _localStorage3.removeItem) === null || _localStorage3$remove === void 0 ? void 0 : _localStorage3$remove.call(_localStorage3, "signupAttribution");
            history.push("/signup");
          case 17:
            _context2.next = 23;
            break;
          case 19:
            _context2.prev = 19;
            _context2.t0 = _context2["catch"](3);
            if (_context2.t0.message == "Some of your employees are assigned") {
              getDeleteUserCountDetails();
              setShowErrModal(true);
            }
            toast.error("Error Occured, Try again later!");
          case 23:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 19]]);
    }));
  }, [organisationDelete, organisationDeleteLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Account")), organisationDetailsLoading ? /*#__PURE__*/React.createElement("div", {
    className: "personal-setting-height"
  }, /*#__PURE__*/React.createElement(Loader, null)) : organisationDetailsError ? /*#__PURE__*/React.createElement("div", null, "Error") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, organisationDetailsData && organisationDetailsData.organisationDetails[0] && Number(organisationDetailsData.organisationDetails[0].userCount) > 1 ? /*#__PURE__*/React.createElement("div", null, " ", "You have to delete all your team members before deleting your account.", /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-card-delete-body-text"
  }, "Please visit \"Manage employees\" page to delete the team members.")) : " Are you sure you want to delete this account?")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, organisationDetailsData && organisationDetailsData.organisationDetails[0] && Number(organisationDetailsData.organisationDetails[0].userCount) <= 1 ? "Cancel" : "Close"), organisationDetailsData && organisationDetailsData.organisationDetails[0] && Number(organisationDetailsData.organisationDetails[0].userCount) <= 1 ? /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteTeam(),
    disabled: Number(organisationDetailsData && organisationDetailsData.organisationDetails[0] && Number(organisationDetailsData.organisationDetails[0].userCount)) > 1 ? true : false
  }, organisationDeleteLoading ? "Loading..." : "Delete") : null)));
};

// const CropImages = React.memo(function CropProfileImages(props) {
//   const { showCropImages, handleClose, upImg, crop, setCrop, setCompletedCrop, onLoad } = props;

//   if (showCropImages === null) {
//     return null;
//   }

//   return (
//     <Modal show={showCropImages} onHide={handleClose} centered size="md" contentClassName="new-employee-modal">
//       <Modal.Header closeButton>
//         <Modal.Title>Crop your photo</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         {/* <Profile /> */}
//         <ReactCrop
//           src={upImg}
//           onImageLoaded={onLoad}
//           crop={crop}
//           onChange={(c) => setCrop(c)}
//           onComplete={(c) => setCompletedCrop(c)}
//           circularCrop={true}
//           locked={true}
//         />
//         {/* <img alt="DeskTime" src={Profile} className="count-tooltip-user-content-img" width="100%" height="300" /> */}
//       </Modal.Body>
//     </Modal>
//   );
// });

export default PersonalInfo;